import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_RATES = 'FETCH_RATES'
export const RECEIVE_RATES = 'RECEIVE_RATES'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_RATES,
	receive: RECEIVE_RATES
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchRates = () => fetch('rates', 'rates', actionTypes)
